import React from 'react'

import { GameWithUserInformation } from 'containers/GamesBlock/types'

import { Image } from '../Game/Image'
import { GameDialogInfo } from './GameDialogInfo'
import { Links } from './Links'
import { DialogBox, ImageBox, Title } from './styles'

interface Props {
  game: GameWithUserInformation
}

export function GameDialog({ game }: Props) {
  const { name } = game

  return (
    <DialogBox>
      <ImageBox>
        <Image
          game={game}
          forceInView
        />
      </ImageBox>

      <Title>{name}</Title>

      <GameDialogInfo game={game} />
      <Links game={game} />
    </DialogBox>
  )
}
